import React from "react";
import { PenLine } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const CAMPI = { stato: "Evacuazione", consistenza: "Consistenza", quantita: "Quantità", note: "Note", aiuto: "Aiuto sanitario", aiuto_note: "Note aiuto" };
const VAL = { si: "Sì", no: "No" };
const v = (x) => (x === null || x === undefined || x === "" ? "— (tolto)" : VAL[x] || String(x));
const fTs = (ts) => { const d = new Date(ts); return isNaN(d) ? "" : d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); };

export function CorrettoBadge({ correzioni, testid, campi = CAMPI }) {
  if (!correzioni?.length) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} className="inline-flex items-center gap-0.5 rounded-full border border-orange-300 bg-orange-50 px-1.5 py-0.5 text-[9px] font-bold uppercase text-orange-700 hover:bg-orange-100" data-testid={testid}>
          <PenLine size={9} /> corretto{correzioni.length > 1 ? ` ×${correzioni.length}` : ""}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-3" data-testid={`${testid}-dettaglio`}>
        <div className="text-xs font-bold mb-2">Correzioni fatte</div>
        <div className="space-y-2.5 max-h-72 overflow-y-auto">
          {[...correzioni].reverse().map((c, i) => (
            <div key={i} className="rounded-md border bg-slate-50 p-2 text-[11px]">
              <div className="text-muted-foreground mb-1">{fTs(c.ts)} · corretto da <b className="text-foreground">{c.operatore || "—"}</b></div>
              {Object.keys(c.dopo || {}).map((f) => (
                <div key={f}><span className="font-semibold">{campi[f] || f}:</span> <span className="line-through text-red-600">{v(c.prima?.[f])}</span> → <span className="font-semibold text-emerald-700">{v(c.dopo[f])}</span></div>
              ))}
              {c.operatore_prima && <div className="text-muted-foreground mt-1">Registrato prima da {c.operatore_prima}</div>}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
